import React from 'react';
import Gauge from './Gauge';
import getScoreClass from '../modules/scoreclass';
import './Report.css';

class Report extends React.Component {

  renderScoreRow = (result, index) => {
    const score = parseInt(result.score, 10) || 0;
    const scoreClass = getScoreClass(score);

    const style = {
      width: `calc(${score}% - 20px)`,
    };

    return (
    <tr key={index}>
      <td>{ result.source }</td>
      <td>{ result.result.result }</td>
      <td>{ result.language }</td>
      <td className="pronounce-results-score-indicator-wrapper" style={{width: '100%'}}><span style={style} className={`pronounce-results-score-indicator ${scoreClass}`}>&nbsp;</span>&nbsp;{score}</td>
    </tr>
  )
}

  render() {
    return (
      <div className="pronounce-report">
        <table className="pronounce-results-table">
          <thead>
            <tr>
              <th>Original</th>
              <th>Transcript</th>
              <th>Language</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>
            {this.props.history.history.map((result, index) => this.renderScoreRow(result, index))}
          </tbody>
        </table>
      </div>
        );
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/components/Report.js